module.exports = __webpack_public_path__ + "assets/d42f95a964e0bee04bd8130d1097a17a.png";